import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError() as any;
  console.error(error);

  return (
    <div id="error-page">
      <h1>Błąd!</h1>
      <p>W aplikacji wystąpił nieobsługiwany błąd.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}
